import {
  IApiResponse,
  IMetaResponse,
} from '@/shared';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { convertQueryCommandToQueryString, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import {
  ITourNylasAccounts,
} from '@llws/lift-entity-interfaces';

interface IToursState {
  nylasAccounts: Array<ITourNylasAccounts>,
}

// Base store configuration
const agentGatewayResourcePathAgent: string = '/tour-api-agent';
const adminGatewayResourcePathAdmin: string = '/tour-api-admin';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {};

const defaultGetSingleFilters: IQueryCommandOptions = {};

const nylasRedirectUri = `http${window.location.host.includes('localhost') ? '' : 's'}://${window.location.host}/tours/nylas/settings/agent-settings`;

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ITourNylasAccounts>({
  adminGatewayResourcePath: adminGatewayResourcePathAdmin,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
    nylasAccounts: [] as Array<ITourNylasAccounts>,

  },

  getters: {
    ...base.getters,
    nylasAccounts(state: IToursState) {
      return state.nylasAccounts;
    },
  },

  mutations: {
    ...base.mutations,

    setUserNylasAccount(state: IToursState, payload: IApiResponse<ITourNylasAccounts[], IMetaResponse>) {
      state.nylasAccounts = payload.data || [];
    },

  },

  actions: {
    ...base.actions,

    getTourNylasAccounts: async (ctx: IAction<IStateStrict<ITourNylasAccounts>>, payload: IQueryCommandOptions) => {
      const response = await adminRequest.get(`${agentGatewayResourcePathAgent}/tour_nylas_accounts${convertQueryCommandToQueryString(payload)}`);
      ctx.commit('setUserNylasAccount', response);
    },
    signinToNylas: (ctx: IAction<IStateStrict<ITourNylasAccounts>>, options: { provider?: string } = {}): void => {
      // Note: The nylas sdk has a function to generate this url for us, but that is
      // another depepndency when we can just create it ourselves
      const queryParams = new URLSearchParams({
        client_id: window?.APP_CONFIG?.VUE_APP_NYLAS_CLIENT_ID!,
        scopes: 'calendar',
        response_type: 'code',
        redirect_uri: nylasRedirectUri,
        ...(options.provider === 'icloud' ? {
          provider: 'icloud',
        } : {}),
        state: 'v3',
      });

      window.open(`https://api.us.nylas.com/v3/connect/auth?${queryParams.toString()}`);
    },
    redirectToNylas: async (_ctx: IAction<IStateStrict<ITourNylasAccounts>>, payload: Record<string, string>) => {
      const response = await adminRequest.post(`${agentGatewayResourcePathAgent}/nylas/v3/redirect`, {
        ...payload,
        redirectUri: nylasRedirectUri,
      });
      return response.data;
    },
    removeNylasAccount: async () => {
      const response = await adminRequest.get(`${agentGatewayResourcePathAgent}/nylas/removeAccount`);
      return response.data;
    },
  },
};
